export default [
    //v4课表
    {
        path: "timetable/semester",
        component: require('@/views/TimeTable/Semester/OperationSemester').default,
    },
    //每日课表
    {
        path: "timetable/daily",
        component: require('@/views/TimeTable/Daily/OperatorDaily').default,
    },
    //月课表
    {
        path: "timetable/monthly",
        component: require('@/views/TimeTable/Monthly/OperationMonthly').default,
    },
    //老师课表
    {
        path: "timetable/teacher",
        component: require('@/views/TimeTable/Teacher/OperationTeacher').default,
    },
    //签到课表
    {
        path: "timetable/signLog",
        component: require('@/views/TimeTable/SignLogDaily/OperatorDaily').default,
    },
]
